import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [agent, setAgent] = useState(null);
  const [properties, setProperties] = useState([]);
  

  useEffect(() => {
    if (typeof window !== "undefined") {
      try {
        const storedAgent = localStorage.getItem("agent");
        if (storedAgent) {
          setAgent(JSON.parse(storedAgent));
        }
      } catch (error) {
        console.error("Erreur de parsing localStorage pour 'agent' :", error);
      }
    }
  }, []);

  const login = (agentData) => {
    setAgent(agentData);
    if (typeof window !== "undefined") {
      try {
        localStorage.setItem("agent", JSON.stringify(agentData));
      } catch (error) {
        console.error("Erreur lors de l'enregistrement dans localStorage :", error);
      }
    }
  };

  const logout = () => {
    setAgent(null);
    setProperties([]);
    if (typeof window !== "undefined") {
      try {
        localStorage.removeItem("agent");
      } catch (error) {
        console.error("Erreur lors de la suppression de 'agent' dans localStorage :", error);
      }
    }
  };

  return (
    <AuthContext.Provider value={{ agent, login, logout, setAgent, properties, setProperties }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
